import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../common/pagination";
import ModernPagination from "../../../common/pagination/ModernPagination";
import Heading from '../../../common/element/Heading';
import ClientInput from "../../../common/element/Input/clientInput";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import ToolManagmentCard from "../../../common/element/Card/ToolManagmnetCard";
import { debounce } from "../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import AddEditBatch from './AddEdit';
import BatchList from './BatchesList';
import { getBatchesList } from '../../../redux/Batches/batchSlice';
import { selectBatchesList, selectBatchesListLoading, selectBatchesListTotal } from '../../../redux/Batches/batchSelector';
import { selectUserData } from '../../../redux/auth/authSelector';
import { ROLES } from '../../../config/rolePermissions';

const Batches = ({ companyId, isAdmin }) => {
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const batches = useSelector(selectBatchesList);
  const batchesTotal = useSelector(selectBatchesListTotal);
  const batchesLoading = useSelector(selectBatchesListLoading);
  const userData = useSelector(selectUserData);
  const isSystemAdmin = userData?.role_name === ROLES.ADMIN;
  const [allBatchesData, setAllBatchesData] = useState([]);

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
    excludeManagement: true,
    company_id: companyId ? Number(companyId) : null
  });

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };
  useEffect(() => {
    setAllBatchesData(batches || []);
    const total = batchesTotal || batches?.length || 0;
    setCountData(total);
    setTotalPages(Math.max(1, Math.ceil(total / (filterlimit || 10))));
  }, [batches, batchesTotal, filterlimit]);
  useEffect(() => {
    if (!companyId) {
      dispatch(
        setBreadcrumbs([
          {
            label: "Batches",
            url: "/batches",
            home: "/dashboard",
          },
        ])
      );
    }
  }, [dispatch, companyId]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);


  const handlePageChange = (page) => {
    setfilterpage(page);
    SetFilterData((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setfilterlimit(limit);
    setfilterpage(1);
    SetFilterData((prev) => ({ ...prev, limit, page: 1 }));
  };

  const handleEdit = (batch) => {
    setSelectedBatch(batch);
    setIsEdit(true);
    setDialogOpen(true);
  };

  const handleAddNew = () => {
    setSelectedBatch(null);
    setIsEdit(false);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedBatch(null);
    setIsEdit(false);
  };
  const { page, limit, search, sort, order, excludeManagement } = getFilterData;

  const fetchBatches = useCallback(() => {

    dispatch(
      getBatchesList({

        page,
        limit,
        search,
        sort,
        order,
        excludeManagement,
        company_id: companyId ? Number(companyId) : null
      })
    );
  }, [dispatch, page, limit, search, sort, order, excludeManagement, companyId]);
  useEffect(() => {
    fetchBatches();
  }, [fetchBatches]);

  if (isSystemAdmin) {
    return (
      <React.Fragment>
        <ToolManagmentCard>
          <div className="flex items-center justify-between mb-4">
            <h4 className="text-start font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">Batches</h4>

            <div className="flex items-center gap-2">
              <div className="input-wrapper mr-2">
                <div className="input-suffix-start left-3.5">
                  <img
                    src="/assets/icons-svg/search-lg.svg"
                    alt=""
                    className="h-5"
                  />
                </div>
                <ClientInput
                  type="text"
                  className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Search"
                  inputchangehandler={inputchangehandler}
                  name={"search"}
                />
              </div>
              <BtnPrimary
                onClick={handleAddNew}
                className="border border-[#FF8E1C] flex items-center justify-center rounded-lg h-9 bg-[#FF8E1C] text-white text-sm font-semibold hover:bg-[#e57d12] focus:bg-[#FF8E1C] duration-100 gap-1 px-5"
              >
                Add Batch
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66732 0.833984V12.5007M0.833984 6.66732H12.5007"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </BtnPrimary>
            </div>
          </div>

          <div className="gap-y-4 border-t border-gray-200 py-2"></div>

          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden ">
            <BatchList
              batches={batches}
              onEdit={handleEdit}
              batchesLoading={batchesLoading}
              fetchBatches={fetchBatches}
              companyId={companyId}
              isAdmin={isAdmin}
            />
          </div>

          <div className="flex justify-between items-center mt-3">
            {/* Left side - Pagination info */}
            <Pagination
              totalCount={countData}
              pageNumber={filterpage}
              displayPage={allBatchesData?.length}
              UpdatePageLimit={handleLimitChange}
              UpdatePage={handlePageChange}
            />

            {/* Right side - Modern Pagination Controls */}
            {countData > 0 && totalPages > 1 && (
              <ModernPagination
                totalPages={totalPages}
                currentPage={filterpage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </ToolManagmentCard>

        <AddEditBatch
          dialogOpen={dialogOpen}
          onDialogClose={handleDialogClose}
          batchData={selectedBatch}
          isEdit={isEdit}
          fetchBatches={fetchBatches}
          companyId={companyId}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3">
          {/* Description text can be added here */}
        </p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Batches</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={handleAddNew}
            className="text-xs h-9 flex items-center justify-center px-3 gap-1"
          >
            Add Batch
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <BatchList
        batches={batches}
        onEdit={handleEdit}
        batchesLoading={batchesLoading}
        fetchBatches={fetchBatches}
        companyId={companyId}
        isAdmin={isAdmin}
      />

      <AddEditBatch
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        batchData={selectedBatch}
        isEdit={isEdit}
        fetchBatches={fetchBatches}
        companyId={companyId}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={allBatchesData?.length}
          UpdatePageLimit={handleLimitChange}
          UpdatePage={handlePageChange}
        />

        {/* Right side - Modern Pagination Controls */}
        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Batches